// extracted by mini-css-extract-plugin
export default {"sideMenuHeader":"styles_side-menu-header__OZ0o4","sideMenuHeader_collapse":"styles_side-menu-header_collapse__oKhz9"};